module.exports = __webpack_public_path__ + "009.ae855b6a.png";